import { VISA_REJECTION_COVER } from '@/constants/fareFamily'
import { isEmpty } from '@/utils/general/browserHelper'

const hasVisaRejectionBenefitTag = (fare: any): boolean => {
    const { benefitTags = [], tags = [] } = fare || {}
    return [...benefitTags, ...tags].some((tag: any) => tag?.benefitType === VISA_REJECTION_COVER)
}

export const isFareVisaRejectionEligible = (fare: any): boolean => {
    if (!fare) return false
    if (hasVisaRejectionBenefitTag(fare)) return true
    const { visaRejectionCover = {} } = fare
    return visaRejectionCover?.eligible === true || visaRejectionCover?.eligible === 'true'
}

type SpecialRtVisaContext = {
    isSpecialRT?: boolean
    cardDetails?: any[]
    subTravelOptions?: Record<string, any>
}

/** Special RT: both legs must have at least one fare in subTravelOption fareList with visa cover. */
export const hasSpecialRtVisaRejectionCover = ({
    cardDetails = [],
    subTravelOptions = {},
}: SpecialRtVisaContext): boolean => {
    if (isEmpty(cardDetails) || cardDetails.length < 2 || isEmpty(subTravelOptions)) {
        return false
    }

    try {
        const onwardSubTravelOptionIds = cardDetails[0]?.subTravelOptionIds || []
        const returnSubTravelOptionIds = cardDetails[1]?.subTravelOptionIds || []

        if (onwardSubTravelOptionIds.length === 0 || returnSubTravelOptionIds.length === 0) {
            return false
        }

        const onwardFareList = subTravelOptions[onwardSubTravelOptionIds[0]]?.fareList || []
        const returnFareList = subTravelOptions[returnSubTravelOptionIds[0]]?.fareList || []

        const onwardHasVisa = onwardFareList.some((f: any) => hasVisaRejectionBenefitTag(f))
        const returnHasVisa = returnFareList.some((f: any) => hasVisaRejectionBenefitTag(f))

        return onwardHasVisa && returnHasVisa
    } catch (e) {
        console.log('Error checking special RT visa rejection cover:', e)
        return false
    }
}

/** Per fare card: direct tags on fare, or special RT leg-level fallback (PWA parity). */
export const isFareVisaRejectionEligibleForDisplay = (
    fare: any,
    context: SpecialRtVisaContext = {}
): boolean => {
    if (isFareVisaRejectionEligible(fare)) return true

    if (context.isSpecialRT && hasSpecialRtVisaRejectionCover(context)) {
        return true
    }

    return false
}

export const isVisaFreeForFare = (fare: any): boolean => {
    const { visaRejectionCover = {}, benefitTags = [], tags = [] } = fare || {}
    const hasVisaCoverField =
        visaRejectionCover?.eligible === true || visaRejectionCover?.eligible === 'true'
    if (hasVisaCoverField) {
        return visaRejectionCover?.premiumDetails?.totalPremiumAmount === 0
    }
    const visaTag = [...benefitTags, ...tags].find((tag: any) => tag?.benefitType === VISA_REJECTION_COVER)
    if (visaTag) {
        const price = Number(String(visaTag?.price ?? '').replace(/,/g, ''))
        return !price
    }
    return false
}

export const isAnyFareVisaRejectionEligible = (
    fares: any[] = [],
    context: SpecialRtVisaContext = {}
): boolean => {
    if (fares.some((fare) => isFareVisaRejectionEligible(fare))) return true
    if (context.isSpecialRT && hasSpecialRtVisaRejectionCover(context)) return true
    return false
}
